export type PlayerAvailabilityState =
  | "availableLimited"
  | "healthy"
  | "longTerm"
  | "out"
  | "shortTerm";

export type PlayerAvailabilityStatus = {
  score: number;
  state: PlayerAvailabilityState;
};

export const getPlayerAvailabilityStatus = ({
  gamesRemaining,
  playingThrough,
  type,
}: {
  gamesRemaining: number;
  playingThrough?: boolean;
  type: string;
}): PlayerAvailabilityStatus => {
  if (gamesRemaining <= 0 && type === "Healthy") {
    return { score: 100, state: "healthy" };
  }

  if (playingThrough) {
    return { score: 65, state: "availableLimited" };
  }

  if (gamesRemaining <= 3) {
    return { score: 48, state: "shortTerm" };
  }

  if (gamesRemaining < 10) {
    return { score: 25, state: "out" };
  }

  return { score: 8, state: "longTerm" };
};

export type RosterInjuryImpactState = "healthy" | "limited" | "major" | "minor";

export type RosterInjuryImpactStatus = {
  score: number;
  state: RosterInjuryImpactState;
};

export const getRosterInjuryImpactStatus = ({
  injuredCount,
  longestAbsence,
}: {
  injuredCount: number;
  longestAbsence: number;
}): RosterInjuryImpactStatus => {
  if (injuredCount === 0) {
    return { score: 100, state: "healthy" };
  }

  if (injuredCount === 1 && longestAbsence <= 3) {
    return { score: 75, state: "minor" };
  }

  if (injuredCount <= 2 && longestAbsence < 10) {
    return { score: 52, state: "limited" };
  }

  return { score: 15, state: "major" };
};
